/**
 * Created by razial on 22.05.2026.
 */

const KingsCupWindow = Prefab.createWindow(
    "kingscup_window",
    "kingscup_window_prefab_json"
);
